import React from 'react';
import { branch } from 'recompose';
import { withRouter } from 'react-router';
import withCreatePage from 'hocs/extends/withCreatePage'
import withEditPage from 'hocs/extends/withEditPage'
import GlobalBanner from 'pages/GlobalBanner';
import CategoryBannerController from './CategoryBannerController';
// TODO : need to remove


// const initialMenu = megaMenuData

const initialCategoryBanners = {
  name: 'Untitled',
  categoryName: '',
  data: {
    deviceContent: {},
  },
};

const CreateOrEditCategoryBanner = (
  branch(
    props => props.params.id,
    withEditPage({
      resourceName: 'categoryBanner',
      getInitialResource: () => ({}),
    }),
    withCreatePage({
      resourceName: 'categoryBanner',
      initialState: initialCategoryBanners,
    }),
  )
)(CategoryBannerController);

CreateOrEditCategoryBanner.propTypes = {};
CreateOrEditCategoryBanner.defaultProps = {};

export default withRouter(CreateOrEditCategoryBanner);



// WEBPACK FOOTER //
// ./src/pages/Banners/children/CategoryBanners/CreateOrEditCategoryBanner.js